import { render, staticRenderFns } from "./UserLogbook.vue?vue&type=template&id=3ca6f170"
import script from "./UserLogbook.vue?vue&type=script&lang=js"
export * from "./UserLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports